"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var context_1 = require("./context");
var ThemeProvider_1 = require("../ThemeProvider");
var styles_1 = require("@material-ui/core/styles");
var react_merge_refs_1 = __importDefault(require("react-merge-refs"));
var HorizontalColumnGrid = react_1.forwardRef(function HorizontalColumnGrid(_a, ref) {
    var _b;
    var children = _a.children, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, _c = _a.spacing, userSpacing = _c === void 0 ? 2 : _c, _d = _a.random, random = _d === void 0 ? false : _d, _e = _a.disableGutters, disableGutters = _e === void 0 ? false : _e;
    var theme = (react_1.useContext(ThemeProvider_1.ThemeContext) || { theme: {} }).theme;
    var breakpoints = ((_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.values) || {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
    };
    var breakpointColumns = react_1.useMemo(function () { return ({
        xs: xs || 2,
        sm: sm || xs || 3,
        md: md || sm || xs || 4,
        lg: lg || md || sm || xs || 5,
        xl: xl || lg || md || sm || xs || 6,
    }); }, [xs, sm, md, lg, xl]);
    var spaceFunction = theme === null || theme === void 0 ? void 0 : theme.spacing;
    var spacing = typeof spaceFunction === 'function' ? spaceFunction(userSpacing) : 0;
    var classes = useStyles({ spacing: spacing, disableGutters: disableGutters });
    var _f = react_1.useState(0), windowWidth = _f[0], setWindowWith = _f[1];
    var _g = react_1.useState(), wrapperRef = _g[0], setWrapperRef = _g[1];
    var _h = react_1.useState([]), items = _h[0], setItems = _h[1];
    var minNumOfItems = 4;
    var columns = react_1.useMemo(function () {
        if (wrapperRef === undefined) {
            return 1;
        }
        var size = Object.keys(breakpoints).reduce(function (result, key) {
            var currentValue = breakpoints[result];
            var value = breakpoints[key];
            if ((wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.offsetWidth) ? (wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.offsetWidth) > value && value > currentValue : false) {
                return key;
            }
            return result;
        }, 'xs');
        return breakpointColumns[size] || 1;
    }, [breakpointColumns, wrapperRef, windowWidth]);
    react_1.useEffect(function () {
        if (children) {
            var originalArr = __spreadArrays(react_1.default.Children.toArray(children));
            if (originalArr.length < minNumOfItems) {
                var placeholders = Array(minNumOfItems - originalArr.length).map(function (_, index) {
                    var theKey = "placeholder" + index;
                    return jsx_runtime_1.jsx("div", {}, theKey);
                });
                var newArr = __spreadArrays(originalArr, placeholders);
                setItems(newArr);
            }
            else {
                setItems(originalArr);
            }
        }
    }, [children]);
    react_1.useEffect(function () {
        var resize = function () {
            setWindowWith(window.outerWidth);
        };
        resize();
        window.addEventListener('resize', resize);
        return function () {
            window.removeEventListener('resize', resize);
        };
    }, []);
    var chunks = items
        .sort(function () { return (random ? 0.5 - Math.random() : 1); })
        .reduce(function (result, child, index) {
        var _a;
        return __assign(__assign({}, result), (_a = {}, _a[index % columns] = __spreadArrays((result[index % columns] || []), [child]), _a));
    }, {});
    var chunkNodes = Object.entries(chunks).map(function (_a) {
        var column = _a[0], elements = _a[1];
        return (jsx_runtime_1.jsx(HorizontalColumn, __assign({ className: classes.column, colCount: columns }, { children: elements }), "column-" + column));
    });
    return (jsx_runtime_1.jsx("div", __assign({ className: classes.wrapper, ref: react_merge_refs_1.default([function (ref) { return setWrapperRef(ref); }, ref]) }, { children: Boolean(wrapperRef) && chunkNodes }), void 0));
});
exports.default = react_1.memo(HorizontalColumnGrid);
function HorizontalColumn(_a) {
    var children = _a.children, colCount = _a.colCount, props = __rest(_a, ["children", "colCount"]);
    var ref = react_1.useRef(null);
    var _b = react_1.useState(null), width = _b[0], setWidth = _b[1];
    react_1.useEffect(function () {
        if (ref.current) {
            var handleWidthChange_1 = function () {
                var newWidth = getWidth(ref.current);
                setWidth(newWidth);
            };
            handleWidthChange_1();
            window.addEventListener('resize', handleWidthChange_1);
            return function () { return window.removeEventListener('resize', handleWidthChange_1); };
        }
        return;
    }, [ref, colCount]);
    return (jsx_runtime_1.jsx("div", __assign({}, props, { ref: ref }, { children: jsx_runtime_1.jsx(context_1.WidthContext.Provider, __assign({ value: { width: width } }, { children: children }), void 0) }), void 0));
}
var useStyles = styles_1.makeStyles(function () { return ({
    wrapper: function (props) { return ({
        display: 'flex',
        width: '100%',
        padding: props.disableGutters ? 0 : props.spacing,
    }); },
    column: function (props) { return ({
        flex: 1,
        paddingRight: props.spacing,
        '& > img': {
            display: 'block',
        },
        '& > *': {
            minWidth: '100%',
            maxWidth: '100%',
            marginBottom: props.spacing,
        },
        '&:last-child': {
            paddingRight: 0,
        },
    }); },
}); });
var getWidth = function (ref) {
    if (!ref || !ref.clientWidth || !getComputedStyle)
        return null;
    var computed = getComputedStyle(ref);
    return ref.clientWidth - (parseFloat(computed.paddingLeft) + parseFloat(computed.paddingRight));
};
//# sourceMappingURL=HorizontalColumnGrid.js.map